import React from 'react';
import './styles.scss';

// The images a creator sent with a message (contract 2.7.0 proposal), at the top of the
// bubble, each with what it was sent for when the creator said so.
export default function MessageAttachments({ attachments, t }) {
  return <div className="studio-message__images" role="group" aria-label={t('attachments')}>
    {attachments.map(item => <figure key={item.asset_id} className="studio-message__image" title={t(`attachRole_${item.role}`)}>
      <img src={item.url} alt={t(`attachRole_${item.role}`)} loading="lazy" />
      {item.role !== 'auto' && <span className="studio-message__image-role">{t(`attachRoleShort_${item.role}`)}</span>}
    </figure>)}
  </div>;
}
